import { Color } from '@diritto/common/style/color';
import { twMerge } from 'tailwind-merge';

export const CopyIcon = ({ color = Color.Gray600, className }: { color?: string; className?: string }) => (
  <svg
    className={twMerge('size-[16px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 2H6C4.9 2 4 2.9 4 4V16H6V4H16V2ZM19 6H10C8.9 6 8 6.9 8 8V20C8 21.1 8.9 22 10 22H19C20.1 22 21 21.1 21 20V8C21 6.9 20.1 6 19 6ZM19 20H10V8H19V20Z"
      fill={color}
    />
  </svg>
);
